import { Box, styled } from '@mui/material';

const cardContainerGap = 48;
const ProfileContainerMargin = 48;

export const ProfileContainer = styled(Box)(() => ({
  width: '100%',
  marginTop: `${ProfileContainerMargin / 1.5}px`,

  display: 'flex',

  '@media screen and (min-width: 1920px)': {
    marginTop: `${ProfileContainerMargin}px`,
  },

  '@media screen and (max-width: 1440px)': {
    marginTop: `${ProfileContainerMargin / 2}px`,
  },

  '@media screen and (max-width: 1024px)': {
    marginTop: `${ProfileContainerMargin / 3}px`,
  },
}));

export const CardsContainer = styled(Box)(() => ({
  maxWidth: '90%',
  margin: 'auto',

  display: 'grid',
  gridTemplateColumns: '1fr 1fr',
  gap: `${cardContainerGap / 1.5}px`,

  '@media screen and (min-width: 1920px)': {
    maxWidth: '80%',
    gap: `${cardContainerGap}px`,
  },

  '@media screen and (max-width: 1440px)': {
    maxWidth: '100%',
    gap: `${cardContainerGap / 2}px`,
  },

  '@media screen and (max-width: 1024px)': {
    gridTemplateColumns: 'none',
    gridTemplateRows: 'auto auto',
  },
}));
